import { render, staticRenderFns } from "./CustomerChalans.vue?vue&type=template&id=0854099f&"
import script from "./CustomerChalans.vue?vue&type=script&lang=js&"
export * from "./CustomerChalans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports